<template>
<div class="">
    <lcontainer class="mb-4">
        <div class="heading flex flex-row items-center justify-between py-2 px-8">
            <div>
                <div class="page text-white mb-4">New Course</div>
            </div>
            <div>
                <img :src="require('../../../assets/tenant_image.png')" alt="" />
            </div>
        </div>
    </lcontainer>
    <lcontainer>
        <div class="bg-white px-8 py-4 ">
            <div>
                <lCrumbs :breadcrumb="breadcrumbItems" />
                <div class="modal-title text-xl tenant-main-color font-semibold mb-2">
                    About Course
                </div>
                <div class="flex flex-row flex-wrap">
                    <div class="w-full my-3 md:w-1/2 flex">
                        <div class="mx-2 mt-2 modal-field font-semibold">Title:</div>
                        <div class="flex-grow ml-auto">
                            <linput type="text" name="fname" v-model="form.title" :errorMessage="errors.title" :error="errors.title" placeholder="Title of Course" />
                        </div>
                    </div>

                    <div class="w-full my-3 md:w-1/2 flex">
                        <div class="mx-2 mt-2 modal-field font-semibold">Caption:</div>
                        <div class="flex-grow ml-auto">
                            <linput type="text" name="fname" v-model="form.caption" :errorMessage="errors.caption" :error="errors.caption" placeholder="e.g The course in 10 words" />
                        </div>
                    </div>

                    <div class="w-full my-3 md:w-1/2 flex">
                        <div class="mx-2 mt-2 modal-field font-semibold">Duration:</div>
                        <div class="flex-grow ml-auto">
                            <linput type="text" v-model="form.duration" :errorMessage="errors.duration" :error="errors.duration" placeholder="e.g 20 days" />
                        </div>
                    </div>

                    <div class="w-full my-3 md:w-1/2 flex">
                        <div class="mx-2 mt-2 modal-field font-semibold">
                            Select Program:
                        </div>
                        <div class="flex-grow ml-auto">
                            <div class="inline-block relative w-64">
                                <select v-model="id" class="block appearance-none w-full   bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline">
                                    <option :value="undefined">Select Program</option>
                                    <option :value="program.value" v-for="(program, idx) in getPrograms" :key="idx">{{ program.text }}</option>
                                </select>
                                <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                    <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="w-full my-3 md:w-1/2 flex">
                        <div class="mx-2 mt-2 modal-field font-semibold">
                            Select Certificate:
                        </div>
                        <div class="flex-grow ml-auto">
                            <lselect :error="errors.type" v-model="form.certificate" :items="certificates" :errorMessage="errors.type" placeholder="Select Certificate" />
                        </div>
                    </div>

                    <div class="w-full my-3 md:w-1/2 flex">
                        <div class="mx-2 mt-2 modal-field font-semibold">
                            Course Instructor:
                        </div>
                        <div class="flex-grow ml-auto">
                            <lselect v-model="form.course_instructor" :errorMessage="errors.course_instructor" :error="errors.course_instructor" :items="instructors" placeholder="Select Course Instructor" />
                        </div>
                    </div>

                    <div class="w-full my-3 md:w-1/2 flex">
                        <div class="mx-2 mt-2 modal-field font-semibold">
                            Overview Video:
                        </div>
                        <div class="flex-grow ml-auto">
                            <lselect :error="errors.course_video" v-model="form.course_video" :errorMessage="errors.course_video" :items="getResources" placeholder="Select Overview Video" />
                        </div>
                    </div>
                    <div class="flex flex-col flex-wrap flex-grow items-start mr-12">
                        <div class="flex flex-row flex-wrap items-center form-row mb-8"></div>
                    </div>
                </div>
            </div>
            <div>
                <div class="modal-title text-xl tenant-main-color font-semibold mb-2">
                    Course Settings
                </div>
                <div class="flex flex-row flex-wrap">

                    <div class="w-full my-3 md:w-1/2 flex">
                        <div class="mx-2 mt-2 modal-field font-semibold">
                            Course Level:
                        </div>
                        <div class="flex-grow ml-auto">
                            <lselect name="course_level" v-model="form.course_level" :errorMessage="errors.course_level" :error="errors.course_level" :items="course_level" placeholder="Select Course Level" />
                        </div>
                    </div>

                    <div class="w-full my-3 md:w-1/2 flex">
                        <div class="mx-2 mt-2 modal-field font-semibold">
                            Publish State:
                        </div>
                        <div class="flex-grow ml-auto">
                            <lselect name="publish" v-model="form.course_state" :errorMessage="errors.course_state" :error="errors.course_state" :items="publish" placeholder="Select Publish State" />
                        </div>
                    </div>

                    <div class="w-full my-3 md:w-1/2 flex">
                        <div class="mx-2 mt-2 modal-field font-semibold">
                            Course Pace:
                        </div>
                        <div class="flex-grow ml-auto">
                            <lselect name="pace" v-model="form.pace" :errorMessage="errors.pace" :error="errors.pace" :items="pacing" placeholder="Select Course Pace" />
                        </div>
                    </div>

                    <div class="w-full my-3 md:w-1/2 flex">
                        <div class="mx-2 mt-2 modal-field font-semibold">
                            Subscription Type:
                        </div>
                        <div class="flex-grow ml-auto">
                            <lselect name="course_subscription_type" v-model="form.course_subscription_type" :errorMessage="errors.course_subscription_type" :error="errors.course_subscription_type" :items="subscription_type" placeholder="Select Subscription Type" />
                        </div>
                    </div>

                    <div v-if="form.course_subscription_type == 'specify'" class="w-full my-3 md:w-1/2 flex">
                        <div class="mx-2 mt-2 modal-field font-semibold">
                            Payment Type:
                        </div>
                        <div class="flex-grow ml-auto">
                            <lselect name="payment_type" v-model="form.payment_type" :errorMessage="errors.payment_type" :error="errors.payment_type" :items="payment" placeholder="Select Payment Type" />
                        </div>
                    </div>

                    <div v-if="
                form.course_subscription_type === 'specify' &&
                  (form.payment_type === 'paid' ||
                    form.payment_type === 'coupon')
              " class="w-full my-3 md:w-1/2 flex">
                        <div class="mx-2 mt-2 modal-field font-semibold">
                            Enter Course Price:
                        </div>
                        <div class="flex-grow ml-auto">
                            <linput name="price" v-model="form.price" :errorMessage="errors.price" :error="errors.price" placeholder="Course Price" />
                        </div>
                    </div>

                    <div v-if="
                form.course_subscription_type === 'inherit' &&
                  getSelectedProgram.subscription.subscription_type ===
                    'discounted'
              " class="w-full my-3 md:w-1/2 flex">
                        <div class="mx-2 mt-2 modal-field font-semibold">
                            Enter Course Price:
                        </div>
                        <div class="flex-grow ml-auto">
                            <linput name="fname" v-model="form.price" :errorMessage="errors.price" :error="errors.price" placeholder="Course Price" />
                        </div>
                    </div>

                    <div v-if="
                form.course_subscription_type === 'specify' &&
                  (form.payment_type === 'paid' ||
                    form.payment_type === 'coupon')
              " class="w-full my-3 md:w-1/2 flex">
                        <div class="mx-2 mt-2 modal-field font-semibold">
                            Select Currency:
                        </div>
                        <div class="flex-grow ml-auto">
                            <lselect name="fname" v-model="form.currency" :errorMessage="errors.currency" :error="errors.currency" :items="currency" placeholder="Select Currency Type" />
                        </div>
                    </div>

                    <div v-if="
                form.course_subscription_type === 'specify' &&
                  (form.payment_type === 'paid' ||
                    form.payment_type === 'coupon')
                      " class="w-full my-3 md:w-1/2 flex row ">
                        <div class="mx-2 mt-2 modal-field font-semibold">
                            Include Subscription Limit:
                        </div>

                        <div class="my-2">
                            <switches color="green" v-model="form.subscription_limit">
                            </switches>
                            <span class="ml-4 mb-2 pb-2 font-bold">{{
                    form.subscription_limit ? "Yes" : "No"
                  }}</span>
                        </div>
                    </div>
                    <div class="w-full md:w-2/5" v-if="form.subscription_limit">
                        How Many Days is this course valid:
                        <linput type="text" v-model="form.subscription_limit_count" :errorMessage="errors.subscription_limit_count" :error="errors.subscription_limit_count" placeholder="e.g 20 ( in days) " />
                    </div>

                    <div class="flex flex-col flex-wrap flex-grow items-start mr-12">
                        <div class="flex flex-row flex-wrap items-center form-row mb-8"></div>
                    </div>
                </div>
            </div>
            <div>
                <div class="modal-title text-xl tenant-main-color font-semibold mb-2">
                    Course Details
                </div>
                <div class="flex flex-row flex-wrap">
                    <div class="w-full md:w-1/2 my-3 px-2 ">
                        <div class="mx-2 mt-2 modal-field font-semibold">
                            Course Description:
                        </div>
                        <p class="text-red-600">{{ errors.description}}</p>

                        <div class="rounded">
                            <div style="height: 150px" ref="editor" class="dmain mb-1"></div>
                        </div>
                    </div>

                    <div class="w-full md:w-1/2 my-3 px-2">
                        <div class="mx-2 mt-2 modal-field font-semibold">
                            What you will learn
                        </div>
                        <p class="text-red-600">{{ errors.skills_to_be_acquired}}</p>

                        <div class="rounded">
                            <div style="height: 150px" ref="editor2" class="dmain mb-1"></div>
                        </div>
                    </div>

                    <div class="w-full md:w-1/2 my-3 px-2">
                        <div class="mx-2 mt-2 modal-field font-semibold">
                            Course Requirements:
                        </div>
                        <p class="text-red-600">{{ errors.resources_required}}</p>
                        <div class="rounded">
                            <div style="height: 150px" ref="editor3" class="dmain mb-1"></div>
                        </div>
                    </div>

                    <div class="w-full my-3 md:w-1/2 px-2">
                        <div class="mx-2 mt-2 modal-field font-semibold">
                            Cover Image:
                        </div>
                        <div class="flex-grow ml-auto">
                            <p class="text-red-600">{{ errors.course_image}}</p>
                            <vue-dropzone @vdropzone-drag-drop="form.course_image = $event" @vdropzone-file-added="form.course_image = $event" ref="myVueDropzone" id="dropzone" :options="dropzoneOptions"></vue-dropzone>
                        </div>
                    </div>
                </div>
                <div v-if="step == 1" class="flex  flex-wrap justify-end items-center">
                    <div class="mb-2 mx-2">
                        <lms-button @click="handleFormSubmit">Add Course</lms-button>
                    </div>
                </div>
            </div>
        </div>
    </lcontainer>
</div>
</template>

<script>
import {
    mapActions,
    mapGetters,
    mapMutations
} from "vuex";
import FormActions from "@/mixins/FormActions";
import Switches from "vue-switches";
import Quill from "quill";
export default {
    mixins: [FormActions],
    data() {
        return {
            id: undefined,
            certificate: null,
            breadcrumbItems: [{
                    disabled: true,
                    to: "/tenant/courses",
                    text: "All Courses",
                },
                {
                    disabled: true,
                    to: "#",
                    text: "Create Course",
                },
            ],
            showAssets: false,
            step: 1,
            instructors: [],
            certificates: [],
            payment: [{
                    text: "Free",
                    value: "free",
                },
                {
                    text: "Paid",
                    value: "paid",
                },
                {
                    text: "Coupon",
                    value: "coupon",
                },
            ],
            currency: [{
                    text: "Naira",
                    value: "NGN",
                },
                {
                    text: "Dollars",
                    value: "DOL",
                },
            ],
            pacing: [{
                    text: "Self-Paced",
                    value: "self",
                },
                {
                    text: "Fixed Timed",
                    value: "fixed",
                },
            ],
            subscription_type: [{
                    text: "Inherit",
                    value: "inherit",
                },
                {
                    text: "Specify",
                    value: "specify",
                },
            ],
            publish: [{
                    text: "Published",
                    value: "published",
                },
                {
                    text: "Draft",
                    value: "draft",
                },
            ],
            course_level: [{
                    text: "Unspecified",
                    value: "",
                },
                {
                    text: "Compulsory",
                    value: "compulsory",
                },
                {
                    text: "Elective",
                    value: "elective",
                },
            ],
            errors: [],
            form: {},
        };
    },
    computed: {
        ...mapGetters(["getTenantPrograms", "getResources"]),
        getPrograms() {
            let programs = this.getTenantPrograms;
            let sortedPrograms = [];
            for (let i = 0; i < programs.length; i++) {
                let temp = {
                    text: programs[i].title,
                    value: programs[i].id,
                };
                sortedPrograms = sortedPrograms.concat(temp);
            }
            return sortedPrograms;
        },
        getSelectedProgram() {
            let programs = this.getTenantPrograms;
            if (!programs) return;
            if (!this.id) return;
            var program = programs.filter(function (current) {
                //console.log({ current });
                return current.id == this.id;
            });
            return program;
        },
    },
    mounted() {
        this.fetchTenantPrograms();
        this.loadResource();
        let options = {
            placeholder: "Create an article...",
            theme: "snow",
            modules: {
                toolbar: {
                    container: [
                        [{
                            header: [1, 2, 3, 4, 5, false]
                        }],
                        ["bold", "italic", "underline", "strike"],
                        ["blockquote"],
                        [{
                            header: 1
                        }, {
                            header: 2
                        }],
                        [{
                            list: "ordered"
                        }, {
                            list: "bullet"
                        }],
                        [{
                            script: "sub"
                        }, {
                            script: "super"
                        }],
                    ],
                },
            },
        };
        setTimeout(() => {
            this.editor = new Quill(this.$refs.editor, options);
            this.editor2 = new Quill(this.$refs.editor2, options);
            this.editor3 = new Quill(this.$refs.editor3, options);
        }, 3000);
    },
    methods: {
        async loadResource(e) {
            let res = await this.loadUserAssets();
            this.showAssets = true;
            let list = await this.tenantAllInstructors();
            list = list.data.data.instructors;
            let instructors = [];
            list.forEach((instructor) => {
                let obj = {};
                obj.text = `${instructor.first_name} ${instructor.last_name}`;
                obj.value = instructor.id;
                instructors.push(obj);
            });
            this.instructors = instructors;
            res = await this.tenantAllCertificates();
            let data = res.data.data.certificates;
            let certificates = [];
            data.forEach((certificate) => {
                let obj = {};
                obj.text = certificate.name;
                obj.value = certificate.id;
                certificates.push(obj);
            });
            this.certificates = certificates;
        },
        ...mapActions([
            "fetchTenantPrograms",
            "tenantCreateCourse",
            "loadUserAssets",
            "tenantAllInstructors",
            "tenantAllCertificates",
        ]),
        ...mapMutations(["updateLoader"]),
        async handleFormSubmit() {
            this.errors = [];
            this.form.description = this.$refs.editor.innerHTML;
            this.form.skills_to_be_acquired = this.$refs.editor2.innerHTML;
            this.form.resources_required = this.$refs.editor3.innerHTML;
            this.form.price = this.form.payment_type === "free" ? 0 : this.form.price;
            this.form.currency = "NGN";
            this.updateLoader(true);
            this.form.course_image = await this.uploadFile(this.form.course_image);
            this.form.normal_course_description = this.getStrippedText(
                this.form.description
            );
            let res = await this.tenantCreateCourse({
                id: this.id,
                course: this.form,
            });
            this.updateLoader(false);

            if (res == true || res.status == 200 || res.status == 201) {
                this.$Bus.$emit("notify", {
                    type: "success",
                    message: "Course created successfully",
                });
                this.form = {};
                this.$router.push({
                    name: "tenant-courses",
                });
            } else {
                this.errors = res.data.errors[0].source;
                this.$Bus.$emit("notify", {
                    type: "error",
                    message: res.data.errors ?
                        res.data.errors[0].title : "An error occured",
                });
            }
        },
        close() {
            this.$emit("closeAdminModal", false);
        },
    },
    components: {
        linput: () => import("@/components/general/input"),
        ltextarea: () => import("@/components/general/textarea"),
        LmsButton: () => import("@/components/general/button"),
        lselect: () => import("@/components/forms/select"),
        lCourseInitial: () => import("@/components/tenant/courses/course-initial"),
        lCourseFinal: () => import("@/components/tenant/courses/course-final"),
        lCrumbs: () => import("@/components/general/breadcrumbs.vue"),
        lcontainer: () => import("@/components/general/container"),
        Switches
    },
};
</script>

<style lang="scss" scoped>
.form-row {
    width: 100%;
}

.modal {
    z-index: 10;

    .overlay {
        background: #b1b3b9;
        opacity: 0.89;
        z-index: 0;
    }

    .modal-content {
        width: 100%;
        width: 1001px !important;

        .modal-title {
            font-size: 24px;
            color: color(lms-tenant);
        }

        .modal-field {
            color: color(lms-tenant);
            max-width: calc(135px + 16px);
            width: 100%;
        }

        .close {
            background-color: #c2454b;
            height: 30px;
            width: 30px;
            border-radius: 50%;
            font-size: 12px;
            top: 0px;
            z-index: 2;
            right: 0px;
        }

        z-index: 1;
    }
}
</style>
